// extracted by mini-css-extract-plugin
export default {"imageSize":"CardFood_imageSize__CZFV9","likesText":"CardFood_likesText__EXJgz"};